import { AlgoliaListing, NormalizedListing } from '@ha/algolia';
import {
  TypeValue,
  RoomsValue,
  GenderFilterValue,
  SearchAreaValue,
  FacilitiesFilterValue,
  TypeFilterValue,
  RoomsFilterValue,
  SortingValue,
  FreePlacesFilterValue,
  MaximumStayFilterValue,
  SearchAreaFilterValue,
  RegistrationFilterValue,
} from 'ha/types/SearchFilters';

export type SearchAlgoliaListingParams = Pick<
  AlgoliaListing,
  | 'id'
  | '_geoloc'
  | 'advertiserAvatar'
  | 'propertyType'
  | 'photos'
  | 'photoCount'
  | 'floorPlanCount'
  | 'videoCount'
  | 'creationDateTS'
  | 'dateFrom'
  | 'dateTo'
  | 'internalID'
  | 'minimumStayMonths'
  | 'priceEUR'
  | 'path'
  | 'thumbnailURL'
  | 'city'
  | 'advertiserId'
  | 'facility_bedroom_count'
  | 'facility_bedroom_furnished'
  | 'facility_bedroom_size'
  | 'facility_total_size'
  | 'facility_bed'
  | 'facility_registration_possible'
  | 'facility_student_housing'
  | 'utilities'
  | 'street'
  | 'currentOccupancy'
  | 'cPolicy'
  | 'minPrice'
  | 'maxPrice'
  | 'priceType'
  | 'contractType'
  | 'country'
  | 'freePlaces'
  | 'maximumStay'
  | 'isPartner'
  | 'objectID'
  | 'unitTypePath'
  | 'isMultiUnit'
  | 'unitTypeInternalID'
>;

export type SearchListing = NormalizedListing<SearchAlgoliaListingParams>;

export type PinListingSubset = Pick<
  AlgoliaListing,
  'id' | 'priceEUR' | 'minPrice' | 'priceType'
>;

export interface MarkerPoint {
  id: string;
  type: 'Feature';
  geometry: {
    type: 'Point';
    coordinates: number[];
  };
  properties: {
    cluster: false;
    rooms: PinListingSubset[];
  };
}

export enum PriceValue {
  FREE = 'free',
  DISCOUNTED = 'discounted',
}
export type PriceFilterValue = PriceValue[];

export interface FilterQueryParams {
  page: number | undefined;
  categories: TypeValue[] | undefined;
  bedroomCount: RoomsValue[] | undefined;
  gender: GenderFilterValue | undefined;
  currency: string | undefined;
  price: PriceFilterValue | undefined;
  freePlaces: FreePlacesFilterValue | undefined;
  maximumStay: MaximumStayFilterValue | undefined;
  searchArea?: SearchAreaValue | undefined;
  facilities: FacilitiesFilterValue | undefined;
  sorting: SortingValue | undefined;
  registration: RegistrationFilterValue | undefined;
}

export interface Filters {
  types?: TypeFilterValue;
  rooms?: RoomsFilterValue;
  price?: PriceFilterValue;
  currency?: string;
  country?: string;
  gender?: GenderFilterValue;
  sorting?: SortingValue;
  facilities?: FacilitiesFilterValue;
  freePlaces?: FreePlacesFilterValue;
  maximumStay?: MaximumStayFilterValue;
  searchArea?: SearchAreaFilterValue;
  registration?: RegistrationFilterValue;
}
